/** @format */

export default {
  data() {
    return {
      pdfLoading: {},
      apiPrint: {
        objects: { url: '/mechti/objects/published' },
        lampObjects: { url: '/mechti/lamp_objects' },
        agentObjects: { url: '/mechti/agent_objects' },
        partnerObjects: { url: '/mechti/partner_objects' },
      },
    };
  },
  computed: {},
  methods: {
    async callForm(e) {
      return this.$refs.editField.show(e);
    },
    async getPdf(row) {
      let res = await this.callForm({
        title: 'Параметры презентации',
        data: { isContact: 1, name: this.$root.profile.name, phone: this.$root.profile.phone },
        model: [
          { name: 'isContact', title: 'Показывать контакты', type: 'switcher', validator: ['req'] },
          { name: 'name', title: 'Имя', type: 'string', validator: ['req'] },
          { name: 'phone', title: 'Телефон', type: 'string', validator: ['req'], mask: '+# (###) ###-##-##' },
        ],
        btn: { ok: 'Скачать', cancel: 'Закрыть' },
      });
      if (res) {
        console.log(res);
        this.openLink4Load(row, 0, res);
      } else {
      }
      return false;
    },
    openLink4Load(row, show = 0, d = {}) {
      const n = this.objectType + '_' + row.id;
      this.$set(this.pdfLoading, n, 1);
      const _arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      };
      let params = d?.isContact ? { name: d.name, phone: d.phone } : {};
      this.$axios({
        method: 'get',
        url: this.$root.config.baseUrl + `${this.apiPrint[this.objectType].url}/${row.id}/print`,
        responseType: 'blob',
        params: { params },
      })
        .then(async (response) => {
          if (show) {
            const blob = response.data;
            const arrayBuffer = await blob.arrayBuffer();
            const base64 = _arrayBufferToBase64(arrayBuffer);
            const tag = document.getElementById('pdf');
            tag.setAttribute('src', 'data:application/pdf;base64,' + base64);
          } else {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${row?.city || ''}_${row.residential_complex_id__text ? row.residential_complex_id__text + '_' : ''}${row.id}.pdf`;
            link.click();

            // Освобождаем память
            window.URL.revokeObjectURL(link.href);
          }
          this.pdfLoading[n] = 0;
        })
        .catch((error) => {
          this.pdfLoading[n] = 2;
          this.$root.$emit('show-info', {
            type: 'error',
            text: 'Ошибка при формировании презентации ',
          });
          console.error('Ошибка при загрузке файла:', error);
        });
      //window.open(url, "_blank");
    },
  },
};
